import type { StudiesSchemaType } from '../stepsMap';

import { yupResolver } from '@hookform/resolvers/yup';
import { useContext } from 'react';
import { useForm } from 'react-hook-form';

import { QuestionPageContext } from '../QuestionPageProvider';
import { studiesSchema } from '../stepsMap';

import StudentQuestion from '$/components/blocks/StudentQuestion';
import Container from '$/components/elements/Container';
import Hint from '$/components/elements/Hint';
import studiesVariantList from '$/components/elements/Questions/lists/studiesVariantList';
import MonthYearInputQuestion from '$/components/elements/Questions/MonthYearInputQuestion';
import SelectAnswerInputQuestion from '$/components/elements/Questions/SelectAnswerInputQuestion';
import useButtonlessFlow from '$/hooks/useButtonlessFlow';
import { TRACKING_ACTION } from '$/utils/tracking/consts';

const Studies = () => {
  const { setCurrentStep, dispatch, state } = useContext(QuestionPageContext);

  const {
    control,
    getValues,
    handleSubmit,
    formState: { isDirty, isValid, dirtyFields },
    trigger,
    setError,
  } = useForm<StudiesSchemaType>({
    mode: 'onChange',
    resolver: yupResolver(studiesSchema),
    defaultValues: state,
  });

  const onSubmit = (payload: StudiesSchemaType) => {
    dispatch({
      type: 'set',
      payload,
    });
    setCurrentStep('previousEducation');
  };

  useButtonlessFlow({
    form: { getValues, handleSubmit, formState: { isDirty, isValid } },
    schema: studiesSchema,
    onSubmit,
  });
  return (
    <StudentQuestion noLimitHeight>
      <Container>
        <MonthYearInputQuestion
          setError={setError}
          title={'Wann beginnt/begann dein Studium?'}
          control={control}
          name={'startDate'}
          onValueSelected={async () => {
            if (dirtyFields.endDate) {
              await trigger('endDate');
            }
          }}
        />
        <MonthYearInputQuestion
          setError={setError}
          title={'Wann planst du das Studium abzuschließen?'}
          control={control}
          name={'endDate'}
        />
        <SelectAnswerInputQuestion
          title={'Welche Studienform hast du gewählt?'}
          list={studiesVariantList}
          control={control}
          name={'variant'}
          errorMessage={null}
          selectFieldElbAction={TRACKING_ACTION.REGISTRATION.PREVIOUS_STUDIES}
        />
        <Hint
          text="Weniger als 25 Std die Woche gilt als Teilzeitstudium"
          style={{ marginTop: '16px' }}
        />
      </Container>
    </StudentQuestion>
  );
};

export default Studies;
